var exports = {
  "q": "x61f99309--89611d--badge",
};

module.exports = exports;
